import React from "react";
import { Helmet } from "react-helmet-async";
import {
  SITE_NAME, DEFAULT_TITLE, DEFAULT_DESC, ogDefault, canonical,
} from "@/lib/seo";

/**
 * Per-route SEO head tags. Googlebot renders JS so dynamic meta is indexed;
 * social crawlers get the server-rendered OG image (backend /api/seo/og/...).
 */
export const Seo = ({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image = ogDefault,
  type = "website",
  jsonLd = [],
  noindex = false,
}) => {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : DEFAULT_TITLE;
  const url = canonical(path);
  const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex
        ? <meta name="robots" content="noindex,nofollow" />
        : <meta name="robots" content="index,follow,max-image-preview:large" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};
